import {Component, parse as iCalParse} from 'ical.js';
import SubHours from 'date-fns/sub_hours';
import ParseDate from 'date-fns/parse';
import Format from 'date-fns/format';

/**
 * Parses the raw data from a .ics file and returns an array of all events from that file
 * @param data
 * @returns {Array}
 */
export default function iCalParser(data) {
  const events = [];

  // Parse the file data into the weird nested array format
  const iCalData = iCalParse(data)[2];
  for (let calEvent of iCalData) {
    // Convert it to something slightly more usable.
    calEvent = new Component(calEvent);

    const summary = calEvent.getFirstProperty('summary').jCal[3];
    if (summary.includes('@ Medicine Hat Tigers')) {
      // parse the date NOTE: THE Z AT THE END IS IMPORTANT OTHERWISE IT DOESNT GET PARSED AS UTC!!!!!!!
      const date = ParseDate(`${calEvent.getFirstProperty('dtstamp').jCal[3]}Z`);
      const productMeeting = Format(SubHours(date, 1.5), 'hh:mm A');
      const showStart = Format(SubHours(date, 1), 'hh:mm A');

      const details = `Production Meeting at: ${productMeeting}\nShow Starts at: ${showStart}`;

      const event = {
        title: summary,
        details,
        date,
        type: 'game',
        assignments: null
      };

      events.push(event);
    }
  }

  return events;
}
